/*
 *  Filter to turn credits into the current currency, based on the country of the interface
 */

import config from '../config';

export function currencyFilter(credits: number) {
    return `€${ (credits / 100).toFixed(2)}`
}

const endZero = (num: number) => `${num}0`.slice(-2);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/filters/euro.ts